import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AdminService } from '../admin.service';
import notify from 'devextreme/ui/notify';

@Component({
  selector: 'app-group-edit',
  standalone: false,
  templateUrl: './group-edit.component.html',
  styleUrls: ['./group-edit.component.css']
})
export class GroupEditComponent implements OnInit {
  isNew = false;
  groupId: number | null = null;
  formData: any = { name: '', contact_name: '', contact_email_address: '', contact_phone: '' };
  members: any[] = [];        // locations currently in the group
  locations: any[] = [];      // all locations (picker)
  newLocationId: any = null;

  constructor(
    private admin: AdminService,
    private route: ActivatedRoute,
    private router: Router
  ) { }

  ngOnInit(): void {
    this.admin.getLocations().subscribe(l => this.locations = this.unwrap(l));

    const idParam = this.route.snapshot.paramMap.get('id');
    if (idParam) {
      this.groupId = +idParam;
      this.loadGroup(this.groupId);
    } else {
      this.isNew = true;
    }
  }

  private unwrap(res: any): any[] {
    return Array.isArray(res) ? res : (res?.data ?? []);
  }

  private loadGroup(id: number): void {
    this.admin.getGroup(id).subscribe(g => {
      const grp = g?.data ?? g;
      if (!grp || !grp.id) {
        notify('Group not found', 'error', 2500);
        this.router.navigate(['/admin/groups']);
        return;
      }
      this.formData = {
        name: grp.name,
        contact_name: grp.contact_name,
        contact_email_address: grp.contact_email_address,
        contact_phone: grp.contact_phone
      };
    });
    this.loadMembers(id);
  }

  private loadMembers(id: number): void {
    this.admin.getGroupLocations(id).subscribe(m => this.members = this.unwrap(m));
  }

  save(): void {
    if (this.isNew) {
      this.admin.createGroup(this.formData).subscribe(() => {
        notify('Group created', 'success', 2000);
        this.router.navigate(['/admin/groups']);
      }, err => notify(err?.error?.message || 'Unable to create group', 'error', 2500));
    } else {
      this.admin.updateGroup(this.groupId!, this.formData).subscribe(() => {
        notify('Group updated', 'success', 2000);
        this.router.navigate(['/admin/groups']);
      }, err => notify(err?.error?.message || 'Unable to update group', 'error', 2500));
    }
  }

  cancel(): void {
    this.router.navigate(['/admin/groups']);
  }

  addLocation(): void {
    if (!this.groupId || !this.newLocationId) {
      notify('Pick a location first', 'warning', 2000);
      return;
    }
    this.admin.assignLocation({ group_id: this.groupId, location_id: this.newLocationId }).subscribe(() => {
      notify('Location added', 'success', 2000);
      this.loadMembers(this.groupId!);
      this.newLocationId = null;
    }, err => notify(err?.error?.message || 'Unable to add location', 'error', 2500));
  }

  onRemoveClick = (e: any): void => { this.removeLocation(e.row.data); };

  removeLocation(loc: any): void {
    if (!this.groupId) { return; }
    this.admin.removeLocation({ group_id: this.groupId, location_id: loc.id }).subscribe(() => {
      notify('Location removed', 'success', 2000);
      this.loadMembers(this.groupId!);
    }, err => notify(err?.error?.message || 'Unable to remove location', 'error', 2500));
  }
}
